// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunk." + "ConfigLazysizes" + "." + "0920ab1151fea7eb2f7e" + ".js";
};